module.exports = __webpack_public_path__ + "img/noble2.2a98c280.png";